import React from "react";
import ReactDOM from "react-dom/client";
import MetaTags from "react-meta-tags";
import webImg from "./logo.svg";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import App from "./App";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCB2UPxMIIdOMmZ48bARrLQAZksWo8pT6I",
  authDomain: "cianjurmediatech.firebaseapp.com",
  projectId: "cianjurmediatech",
  storageBucket: "cianjurmediatech.appspot.com",
  messagingSenderId: "359320014926",
  appId: "1:359320014926:web:5d06f4ab6b5743e5e2b31f",
  measurementId: "G-G8DJJF88KG",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const root = ReactDOM.createRoot(document.getElementById("content"));
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
]);

root.render(
  <React.StrictMode>
    <MetaTags>
      <title>Cianjur Media Tech.</title>
      <meta
        name="description"
        content="What we call Cianjur Media Tech. or with the abbreviation CMT, is a website development service in the Cianjur district, West Java."
      />
      <meta property="og:title" content="Cianjur Media Tech." />
      <meta property="og:image" content={webImg} />
    </MetaTags>

    <RouterProvider router={router} />
  </React.StrictMode>
);

logEvent(analytics, "notification_received");
